<template>
  <div class="dialog-background" v-show="show">
    <div class="dialog-box">
      <div class="dialog-nav">
        <div class="dialog-nav-main">
          <div class="dialog-nav-title">
            <h2 style="padding-left: 16px">{{title}}</h2>
            <h2 @click="close" style="margin-right: 24px"><icon name="close" /></h2>
          </div>
        </div>
        <div class="dialog-nav-menu">
          <slot name="menu"></slot>
        </div>
      </div>
      <b-container style="padding-top: 24px; padding-bottom: 32px">
        <slot></slot>
      </b-container>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      page: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        show: false
      }
    },
    watch: {
      show (val) {
        if (val) {
          this.hideBodyScroll()
        } else {
          this.showBodyScroll()
        }
      }
    },
    activated () {
      this.show = true
    },
    deactivated () {
      this.show = false
    },
    created () {
      if (this.page) {
        this.show = true
        this.hideBodyScroll()
      } else {
        this.$root.$on('mDialogShow', name => {
          if (name === this.name) {
          }
        })

        this.$root.$on('mDialogClose', name => {
          if (name === this.name) {
            this.show = false
          }
        })
      }
    },
    methods: {
      close () {
        this.showBodyScroll()
        this.$emit('close')
      },
      hideBodyScroll () {
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
      },
      showBodyScroll () {
        document.getElementsByTagName('body')[0].style.overflow = 'auto'
      }
    }
  }
</script>

<style scoped lang="scss">
  .dialog-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    overflow-x: hidden;
    background: rgba(0, 0, 0, 0.5)
  }
  .dialog-box {
    position: fixed;
    left: 8px;
    right: 0;
    top: 0;
    width: calc(100vw - 8px);
    max-width: calc(100vw - 8px);

    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    /*min-height: calc(100vh-24px);*/
    background: $color-body;
  }
  .dialog-nav {
    background: #fff;
    width: 100vw;
    padding: 12px 24px 12px 16px;
  }
  .dialog-nav-menu{
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .dialog-nav-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dialog-nav-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .container {
    padding-right: 0;
    padding-left: 0;
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/MDialog.vue